// Module
var code = "<template>\n    <button type.bind=\"type\" \n        class=\"btn ${sizeClass} btn-${color} ${buttonClass}\" \n        click.delegate=\"onClick($event)\"\n        title=\"'Button_Add' | resource\">\n        <i if.bind=\"icon\" class=\"glyphicon glyphicon-${icon}\"></i>\n        <slot></slot>\n    </button>\n</template>\n";
// Exports
export default code;